import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

export default function useSearchBar(redirect) {
  const { setSearchTerm, searchTerm, setResponseMsg, documents } = useContext(GlobalContext);
  const [searchInputValue, setSearchInputValue] = useState(searchTerm);
  const history = useHistory();
  let debounce;

  useEffect(() => {
    return () => setSearchTerm('');
  }, [setSearchTerm]);

  const handleOnChange = (input) => {
    clearTimeout(debounce);
    setSearchInputValue(input.target.value);
    debounce = setTimeout(() => {
      setSearchTerm(input.target.value);
    }, 500);
    if (redirect) {
      history.location.pathname !== '/' && history.push('/');
    }
  };

  async function onSubmit(e) {
    e.preventDefault();
    try {
      if (!searchInputValue) return;

      if (documents?.length <= 0) {
        throw new Error('Não conseguimos encontrar documentos com este(s) termos. Tente novamente.');
      }
      setSearchTerm(searchInputValue.toLowerCase());
    } catch (error) {
      console.error(error.message);
      setResponseMsg({ isVisible: true, error: true, msg: error.message });
    }
    if (redirect && history.location.pathname !== '/') {
      history.push('/'); //If didn't stay on home, go to home to list Documents
    }
    setSearchInputValue('');
    e.target.search.blur();
  }

  return { onSubmit, searchInputValue, handleOnChange };
}
